import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { api } from "../../common/setupApi";

export const getSessions = createAsyncThunk(
  "sessions/get",
  async (_, { rejectWithValue }) => {
    return api
      .get("session-types/")
      .then((res) => {
        const withoutWellness = res.data.filter((d) => d.id !== 1);
        return withoutWellness;
      })
      .catch((err) => {
        return rejectWithValue(err.response?.data);
      });
  },
  {
    condition: (params, { getState }) => {
      if (params?.ignoreCondition) {
        return true;
      }
      // https://redux-toolkit.js.org/api/createAsyncThunk#canceling-before-execution
      const { status } = selectSessions(getState());
      if (status === "fulfilled" || status === "pending") {
        // Already fetched or in progress, don't need to re-fetch
        return false;
      }
    },
  }
);

const initialState = {
  status: "idle",
  data: [],
  error: null,
};

const sessionsSlice = createSlice({
  name: "sessions",
  initialState,
  reducers: {
    add: (state, action) => {
      state.data.push(action.payload);
    },
    delete: (state, action) => {
      state.data = state.data.filter((d) => d.id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSessions.pending, (state) => {
        state.status = "pending";
        state.error = null;
      })
      .addCase(getSessions.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.data = action.payload;
      })
      .addCase(getSessions.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      })
      .addCase("auth/logout", () => initialState);
  },
});

export const sessionsActions = sessionsSlice.actions;

const _selectSessions = (state) => state.sessions;

export const selectSessions = createSelector(
  [(state) => _selectSessions(state)],
  (sessions) => {
    const data = sessions.data;
    const status = sessions.status;
    const error = sessions.error;
    const isLoading = status === "pending";
    return { data, status, error, isLoading };
  }
);

export const selectSelectedSession = createSelector(
  [(state) => selectSessions(state).data, (state, id) => id],
  (sessions, id) => sessions.find((d) => String(d.id) === id)
);

// We have to wait the status to be fulfilled
export const selectUserHasCreatedSessionType = createSelector(
  [(state) => selectSessions(state)],
  (sessions) => {
    const data = sessions.data;
    const created = data.filter((d) => {
      const sessionId = d.id;
      return sessionId !== 2 && sessionId !== 3;
    });
    return Boolean(created.length);
  }
);

export default sessionsSlice.reducer;
